<div class="flex items-center p-0">
  <label [for]="id" style="display: none"></label>
  <div class="w-full font-normal text-sm text-black-800 font-inter-medium">
    <ng-template #fieldComponent></ng-template>
  </div>

  <div *ngIf="showError" class="col-sm-3 invalid-feedback d-block">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
</div>
